import React from 'react';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import OfficeLogo from 'assets/images/OfficeBlue.svg';
import { Box, Grid, Typography } from '@mui/material';

function EmployeeCompanyProfile(props) {
  const companyData = props?.companyProfile;

  const headOffice = companyData?.branch?.filter(
    (item) => item.isHeadquarter === true
  )[0];

  const branches = companyData?.branch?.filter(
    (item) => item.isHeadquarter !== true
  );

  const formatAddress = (address, city, state) => {
    return `${address}, ${city}, ${state}`;
  };

  const details = {
    companyDetails: {
      'Company Name': companyData?.name || 'NA',
      'Parent Company Name ': companyData?.parentCompanyName || 'NA',
      'Phone No.': companyData?.phoneNumber || 'NA',
      'Email ID': companyData?.email || 'NA',
    },
    headOfficeAddress: {
      'Head Office Address':
        formatAddress(
          headOffice?.address || '',
          headOffice?.cityName || '',
          headOffice?.state || ''
        ) || 'NA',
    },
  };
  return (
    <div className="p30">
      <ArrowBackIosRoundedIcon
        className="font24 colorGrey"
        role="presentation"
        onClick={() => window.history.go(-1)}
      />
      <div className="p30 mt20 backgroundColorlightGrey">
        <Box className="justifyStart">
          <img src={OfficeLogo} alt="company" className="mr10 w36" />
          <Typography variant="head3" className="colorPrimary fw600  ">
            Company Profile
          </Typography>
        </Box>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className="paddingTop30Left40"
        >
          {Object.entries(details?.companyDetails).map((objData, index) => (
            <Grid item md={3} sm={6} xs={12}>
              <Typography variant="body2">{objData[0]}</Typography>
              <Typography variant="body1" className="colorGrey">
                {objData[1]}
              </Typography>
            </Grid>
          ))}
        </Grid>
        <div className="marginLeft50 dashedBorderLightGrey"></div>
        <Grid className="paddingTop30Left40">
          {Object.entries(details?.headOfficeAddress).map((objData, index) => (
            <Grid item md={3} sm={6} xs={12}>
              <Typography variant="body2">{objData[0]}</Typography>
              <Typography variant="body1" className="colorGrey">
                {objData[1]}
              </Typography>
            </Grid>
          ))}
        </Grid>
        <div className="marginLeft50 dashedBorderLightGrey"></div>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="paddingTop30Left40"
        >
          {branches?.map((branch, index) => (
            <>
              <Grid item md={5} xs={12} pr={2}>
                <Typography variant="body2">
                  Branch {index + 1} Office Address
                </Typography>
                <Typography variant="body1" className="colorGrey">
                  {formatAddress(
                    branch?.address || '',
                    branch?.cityName || '',
                    branch?.state || ''
                  )}
                </Typography>
              </Grid>
              {(index + 1) % 2 === 0 && (
                <Grid item xs={12}>
                  <div className="mtb20 dashedBorderLightGrey"></div>
                </Grid>
              )}
            </>
          ))}
        </Grid>
      </div>
    </div>
  );
}

export default EmployeeCompanyProfile;
